import { render } from "./TabPanelPDB.vue?vue&type=template&id=3e7557a6"
import script from "./TabPanelPDB.vue?vue&type=script&lang=js"
export * from "./TabPanelPDB.vue?vue&type=script&lang=js"

import "./TabPanelPDB.vue?vue&type=style&index=0&id=3e7557a6&lang=css"
script.render = render

export default script